import { getValue } from "../../utils/object.utils";

export const transformLunchPackagesListTableData = (
  lunchPackagesList: Array<any>
): any[] => {
  const transformDatForTable = lunchPackagesList.map(
    (lunchPackage: any): any => {
      return {
        id: getValue(lunchPackage, "id"),
        name: getValue(lunchPackage, "package_name"),
        rate: getValue(lunchPackage, "rate"),
      };
    }
  );

  return transformDatForTable;
};
